import { Buttons } from './index';

const {
  AddNewButton,
  ButtonFooter,
  CancelButton,
  DeleteButton,
  DuplicateButton,
  EditViewToggleButton,
  ExportButton,
  FloatingActionMenu,
  HSCButton,
  OpenDetailsButton,
  QuickViewButton,
  SaveButton,
  StatusToggleButton,
  UndoButton,
} = Buttons;

export {
  AddNewButton,
  ButtonFooter,
  CancelButton,
  DeleteButton,
  DuplicateButton,
  EditViewToggleButton,
  ExportButton,
  FloatingActionMenu,
  HSCButton,
  OpenDetailsButton,
  QuickViewButton,
  SaveButton,
  StatusToggleButton,
  UndoButton,
};
